const SSE_RECONNECT_BASE_DELAY_MS = 1000;
const SSE_RECONNECT_MAX_DELAY_MS = 60000;

export const getSseReconnectDelay = (attempt: number) =>
  Math.min(SSE_RECONNECT_MAX_DELAY_MS, SSE_RECONNECT_BASE_DELAY_MS * 2 ** attempt);
